import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Layout } from 'antd';
import { routes } from 'configs/routes';
import UnAuthorized from 'pages/Error/403';
import NotFound from 'pages/Error/404';
import ErrorPage from 'pages/Error/500';

const { Content } = Layout;

const LContent = () => (
  <Content className='leahContent'>
    <Switch>
      {routes.map((route, index) => (
        <Route key={index} exact={route.exact} path={route.path} component={route.Component} />
      ))}
      <Route path='/403' component={UnAuthorized} />
      <Route path='/500' component={ErrorPage} />
      <Route path='*' component={NotFound} />
    </Switch>
  </Content>
);

export default React.memo(LContent);
